<template>
  <div class="bg p-3 pb-20 mb-auto h-full overflow-auto bg-gradient-to-b bg-gray-800" id="style-1">
    <!-- Loading -->
    <div v-if="isLoading" class="flex justify-center items-center h-full">
      <div class="animate-spin rounded-full h-12 w-12 border-t-4 border-indigo-500"></div>
    </div>
    <!-- Content -->
    <div v-else>
      <!-- ปุ่มอัปเกรดความจุค่าย (ย้ายมาซ้ายบน) -->
      <div class="mb-4 flex justify-between items-center">
        <button type="button"
          @click="openCapacityModal"
          class="px-4 py-2 text-white bg-indigo-700 hover:bg-indigo-600 rounded text-sm"
          title="อัปเกรดความจุค่าย"
        >
          <i class="fas fa-tent mr-1"></i> อัปเกรดความจุค่าย ({{ capacity }}/{{ maxCapacity }})
        </button>
      </div>
      <!-- Filter -->
      <div class="flex justify-end items-center mb-4">
        <label class="text-indigo-200 text-sm mr-2">เรียงรองตาม:</label>
        <select v-model="sortBy" class="bg-gray-700 text-indigo-200 px-3 py-1 rounded border border-gray-600 focus:outline-none focus:border-indigo-500 transition">
          <option value="level">เลเวล</option>
          <option value="attackDice">ลูกเต๋าโจมตี</option>
          <option value="defenseDice">ลูกเต๋าป้องกัน</option>
          <option value="stamina">ความอึด (sta)</option>
          <option value="str">พละกำลัง (str)</option>
          <option value="agi">ความคล่องตัว (agi)</option>
          <option value="int">สติปัญญา (int)</option>
          <option value="luck">โชค (luck)</option>
          <option value="defense">ป้องกัน (def)</option>
        </select>
      </div>
      <!-- เมื่อมีชาวบ้าน -->
      <div v-if="villagers.length > 0" class="space-y-4">
        
        <!-- กริดการ์ดชาวบ้าน -->
        <div class="grid grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4">
          <div
            v-for="v in sortedVillagers"
            :key="v.id"
            class="group relative bg-gray-900 bg-opacity-60 rounded-2xl border border-gray-800 overflow-hidden hover:border-indigo-600 transition"
          >
            <!-- ส่วนหัว: ภาพ + ชื่อ + เลเวล -->
            <div class="p-3 flex items-center">
              <div class="relative">
                <img
                  :src="v.template?.normalFace || v.template?.img || 'default-villager.png'"
                  alt="Villager"
                  class="w-14 h-14 rounded-lg object-cover border-2 border-indigo-500 bg-gray-800"
                  @error="handleImageError"
                />
                <div
                  v-if="getLevel(v)"
                  class="absolute -bottom-2 left-1/3 transform -translate-x-1/2 px-2 py-0.5 rounded text-xxs bg-indigo-600 text-white shadow"
                >
                  {{ getLevel(v) }}
                </div>
              </div>
              <div class="ml-3 flex-1">
                <div class="flex items-center justify-between">
                  <div class="font-semibold text-gray-100 truncate">
                    {{ v.template?.name || v.templateId }} 
                  </div>
                  
                </div>
                <div class="flex items-center space-x-1 px-1">
                  <!-- ชิปบุก -->
                  <div class="flex items-center space-x-1 px-2 py-0.5 rounded bg-red-900 opacity-80 text-white text-xxs border border-red-600">
                    <i class="fa-solid fa-dice text-red-300 text-xs"></i>
                    <span class="font-mono">6</span>
                  </div>
                  <!-- ชิปตั้งรับ -->
                  <div class="flex items-center space-x-1 px-2 py-0.5 rounded bg-blue-900 opacity-80 text-white text-xxs border border-blue-600">
                    <i class="fa-solid fa-dice text-blue-300 text-xs"></i>
                    <span class="font-mono">6</span>
                  </div>
                </div>
                <div class="text-xs text-gray-400 truncate" v-if="v.template?.note">
                  {{ v.template.note }}
                </div>
              </div>
            </div>
            <!-- แท็บสเตตัสแบบย่อ -->
            <div class="px-3 pb-3 space-y-2">
              <!-- ชิปค่าอื่นๆ -->
              <div class="grid grid-cols-3 gap-1">
                <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  sta: {{ getTotalStat(v,'stamina') }}
                </span>
                <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  str: {{ getTotalStat(v,'str') }}
                </span>
                 <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  agi: {{ getTotalStat(v,'agi') }}
                </span>
                <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  int: {{ getTotalStat(v,'int') }}
                </span>
                <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  luck: {{ getTotalStat(v,'luck') }}
                </span>
                <span class="px-2 py-0.5 rounded bg-gray-800 text-gray-300 text-xxs border border-gray-700">
                  def: {{ getTotalStat(v,'defense') }}
                </span>
              </div>
            </div>
            <div class="px-3 pb-3 flex items-center">
              <div v-if="remainingMs(v) > 0" class="flex items-center text-yellow-400 text-xxs">
                <i class="fas fa-hourglass-half mr-1 animate-pulse"></i>
                <span class="font-medium">สามารถบุกได้หลัง</span> {{ formatRemaining(remainingMs(v)) }}
              </div>
              <div v-else class="flex items-center text-green-400 text-xxs">
                <i class="fas fa-check-circle mr-1"></i>
                <span class="font-medium">พร้อมใช้งาน</span>
              </div>
              <button type="button"
                v-if="isAdmin && remainingMs(v) > 0"
                @click="resetCooldown(v)"
                class="ml-2 text-xs bg-purple-600 hover:bg-purple-500 text-white px-2 py-0.5 rounded transition"
              >
                Reset
              </button>
            </div>
            <!-- Action Footer -->
            <div class="px-3 pb-3">
              <div class=" w-full">
                <div class="grid grid-cols-1 gap-0.5">
                  <button type="button"
                    class="px-2 py-1 text-white bg-indigo-700 hover:bg-indigo-600 rounded text-xs"
                    @click="openPowerModal(v)"
                    title="ข้อมูล"
                  >
                    <i class="fas fa-info-circle mr-1"></i> ข้อมูล
                  </button>
                  <button type="button"
                    class="px-2 py-1 text-white bg-indigo-700 hover:bg-indigo-600 rounded text-xs"
                    @click="openUpgradeModal(v)"
                    title="อัปเกรด"
                  >
                    <i class="fas fa-plus mr-1"></i> อัปเกรด
                    <span class="text-xs text-white" v-if="v.statPoints">({{ v.statPoints }} Points)</span>
                  </button>
                  <button type="button"
                    class="px-2 py-1 text-white bg-indigo-700 hover:bg-indigo-600 rounded text-xs"
                    @click="openDismissModal(v)"
                    title="ไล่ออก"
                  >
                    <i class="fas fa-user-times mr-1"></i> ไล่ออก
                  </button>
                </div>
              </div>
            </div>
            <!-- เส้นไฮไลต์ขอบบนเมื่อโฮเวอร์ -->
            <div class="absolute inset-x-0 top-0 h-1 bg-indigo-600 opacity-0 group-hover:opacity-100 transition"></div>
          </div>
        </div>
      </div>
      <!-- เมื่อไม่มีชาวบ้าน -->
      <div v-else class="text-center text-gray-300 py-10">
        <div class="mx-auto w-16 h-16 rounded-full bg-gray-800 border border-gray-700 flex items-center justify-center mb-3">
          <i class="fas fa-users-slash text-gray-500"></i>
        </div>
        <div class="text-lg text-gray-200 mb-2">คุณยังไม่มีชาวบ้านที่จ้างมา</div>
        <div class="text-sm text-gray-400 mb-4">เริ่มสร้างกองกำลังให้แข็งแกร่งขึ้นด้วยการค้นหาชาวบ้านจากการสำรวจสถานที่ต่างๆ</div>
      </div>
    </div>
  </div>
  <!-- Migration Modal -->
  <div v-if="showMigrateModal" class="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center p-4 z-50">
    <div class="bg-gray-800 text-indigo-200 rounded-md shadow-2xl border border-gray-700 p-6 max-w-sm w-full text-center">
      <div class="mx-auto w-16 h-16 rounded-full bg-yellow-900 bg-opacity-30 border border-yellow-600 flex items-center justify-center mb-4">
        <i class="fas fa-exclamation-triangle text-yellow-400 text-2xl"></i>
      </div>
      <h3 class="text-lg font-semibold text-yellow-300 mb-2">ต้อง Migrate ชาวบ้าน</h3>
      <p class="text-sm text-gray-400 mb-4">ระบบชาวบ้านถูกอัปเกรดเป็น V2 คุณต้อง migrate ชาวบ้านก่อนจึงจะสามารถใช้งานได้</p>
      <button type="button"
        @click="migrateVillagers"
        :disabled="isMigrating"
        class="w-full px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white rounded text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <span v-if="isMigrating"><i class="fas fa-spinner animate-spin mr-2"></i>กำลัง migrate...</span>
        <span v-else>Migrate ตอนนี้</span>
      </button>
    </div>
  </div>
  <!-- Modals -->
  <DismissVillagerModal
    v-if="showDismissModal"
    :villager="selectedVillager"
    @close="showDismissModal = false"
    @dismissed="handleDismissed"
  />
  <UpgradeVillagerModal
    v-if="showUpgradeModal"
    :villager="selectedVillager"
    @close="showUpgradeModal = false"
    @updated="handleUpdated"
  />
  <VillagerPowerModal
    v-if="showPowerModal"
    :villager="selectedVillager"
    @close="showPowerModal = false"
  />
  <UpgradeCapacityModal
    v-if="showCapacityModal"
    @close="showCapacityModal = false"
    @updated="handleUpdated"
  />
</template>
<script>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { projectFirestore, projectFunctions, FieldValue } from '@/firebase/config';
import getUser from '@/composables/getUser';
import { usePlayerStore } from '@/composables/usePlayerStore';
import gameVillagersData from '@/data/gameVillagers.json';
import DismissVillagerModal from '@/components/villager/DismissVillagerModal.vue';
import UpgradeVillagerModal from '@/components/villager/UpgradeVillagerModal.vue';
import VillagerPowerModal from '@/components/villager/VillagerPowerModal.vue';
import UpgradeCapacityModal from '@/components/villager/UpgradeCapacityModal.vue';

export default {
  emits: ['addVillager'],
  components: {
    DismissVillagerModal,
    UpgradeVillagerModal,
    VillagerPowerModal,
    UpgradeCapacityModal,
  },
  setup(_, { emit }) {
    const { user } = getUser();
    const villagers = ref([]);
    const isLoading = ref(true);
    const selectedVillager = ref(null);
    const showDismissModal = ref(false);
    const showUpgradeModal = ref(false);
    const showPowerModal = ref(false);
    const showCapacityModal = ref(false);
    const showMigrateModal = ref(false);
    const isMigrating = ref(false);
    let campUnsub = null;
    const currentTime = ref(Date.now());
    let interval = null;
    const isAdmin = ref(false);
    const sortBy = ref('attackDice');
    const capacity = ref(0);
    const maxCapacity = ref(10);

    const sortedVillagers = computed(() => {
      return [...villagers.value].sort((a, b) => {
        const levelA = getLevel(a);
        const levelB = getLevel(b);
        if (levelA !== levelB) return levelB - levelA; // desc

        let secondaryA, secondaryB;
        if (sortBy.value === 'level') {
          secondaryA = levelA;
          secondaryB = levelB;
        } else if (sortBy.value === 'attackDice' || sortBy.value === 'defenseDice') {
          secondaryA = getDice(a, sortBy.value);
          secondaryB = getDice(b, sortBy.value);
        } else {
          secondaryA = getTotalStat(a, sortBy.value);
          secondaryB = getTotalStat(b, sortBy.value);
        }
        return secondaryB - secondaryA; // desc
      });
    });

    const playerStore = usePlayerStore();

    watch(() => playerStore.userData, (data) => {
      if (data) {
        isAdmin.value = data.admin === true;
      } else {
        isAdmin.value = false;
      }
    }, { immediate: true });

    const handleImageError = (event) => {
      event.target.src = 'https://via.placeholder.com/64?text=No+Image';
    };

    const onAddClick = () => {
      emit('addVillager');
    };

    const closeAllModals = () => {
      showDismissModal.value = false;
      showUpgradeModal.value = false;
      showPowerModal.value = false;
      showCapacityModal.value = false;
    };

    const openDismissModal = (v) => {
      closeAllModals();
      selectedVillager.value = v;
      showDismissModal.value = true;
    };

    const openUpgradeModal = (v) => {
      closeAllModals();
      selectedVillager.value = v;
      showUpgradeModal.value = true;
    };

    const openPowerModal = (v) => {
      closeAllModals();
      selectedVillager.value = v;
      showPowerModal.value = true;
    };

    const openCapacityModal = () => {
      closeAllModals();
      selectedVillager.value = null;
      showCapacityModal.value = true;
    };

    const handleDismissed = () => {
      // No need for manual filter; real-time listener will update
    };

    const handleUpdated = () => {
      // No need for manual fetch; real-time listener will update
    };

    const updateVillagersList = (campVillagers) => {
      const list = Object.entries(campVillagers || {}).map(([id, v]) => {
        const tpl = gameVillagersData[v.templateId] || {};
        return {
          id,
          ...v,
          ...tpl,
          ...v.states,
          template: tpl,
        };
      });
      villagers.value = list;
    };

    const cleanupListeners = () => {
      if (campUnsub) {
        campUnsub();
        campUnsub = null;
      }
      villagers.value = [];
      isLoading.value = true;
    };

    const setupListeners = () => {
      if (!user.value) {
        cleanupListeners();
        return;
      }
      const uid = user.value.uid;

      campUnsub = projectFirestore.collection('camps').doc(uid).onSnapshot((snap) => {
        if (snap.exists) {
          const campData = snap.data();
          const campVillagers = campData.villagers || {};
          capacity.value = Object.keys(campVillagers).length;
          maxCapacity.value = campData.capacity || 10;

          // Check for old V1 villagerIds array
          const hasOldVillagerIds = Array.isArray(campData.villagerIds) && campData.villagerIds.length > 0;
          let schemaVersion = campData.villagerSchemaVersion || 1;

          if (hasOldVillagerIds && schemaVersion === 2) {
            // Let backend auto-fix schema version instead of updating directly
            projectFunctions.httpsCallable('gameActions')({
              action: 'outpostActions',
              subAction: 'checkCampSchema'
            }).catch(err => console.error('Error checking camp schema:', err));
            schemaVersion = 1;
          }

          if (schemaVersion !== 2) {
            showMigrateModal.value = true;
            villagers.value = [];
            isLoading.value = false;
            return;
          }
          showMigrateModal.value = false;

          updateVillagersList(campVillagers);
          isLoading.value = false;
        } else {
          villagers.value = [];
          capacity.value = 0;
          isLoading.value = false;
        }
      }, (error) => {
        console.error('Error listening to camp:', error);
        isLoading.value = false;
      });
    };

    const migrateVillagers = async () => {
      if (!user.value?.uid) return;
      isMigrating.value = true;
      try {
        const { data } = await projectFunctions.httpsCallable('gameActions')({
          action: 'outpostActions',
          subAction: 'migrateCampVillagers'
        });
        if (data.success) {
          showMigrateModal.value = false;
        }
      } catch (err) {
        console.error('Error migrating villagers:', err);
        alert('ไม่สามารถ migrate ชาวบ้านได้: ' + (err.message || 'เกิดข้อผิดพลาด'));
      } finally {
        isMigrating.value = false;
      }
    };

    const getBaseStats = (v) => {
      return v.template?.stats || {};
    };

    const getUpgradeStats = (v) => {
      return v.states?.upgradeStats || {};
    };

    const getTotalStat = (v, key) => {
      const base = getBaseStats(v)[key] || 0;
      const upgrade = getUpgradeStats(v)[key] || 0;
      return base + upgrade;
    };

    const getDice = (v, key) => {
      return v.template?.[key] ?? 0;
    };

    const getLevel = (v) => {
      return v.states?.level ?? v.template?.level ?? 0;
    };

    const remainingMs = (v) => {
      const lastUsed = v.states?.lastUsedInAttackAt;
      if (!lastUsed) return 0;
      const last = lastUsed.toDate ? lastUsed.toDate().getTime() : new Date(lastUsed).getTime();
      const cooldown = 20 * 60 * 60 * 1000;
      const elapsed = currentTime.value - last;
      return Math.max(0, cooldown - elapsed);
    };

    const formatRemaining = (ms) => {
      if (ms <= 0) return '00:00:00';
      const hours = Math.floor(ms / 3600000);
      const minutes = Math.floor((ms % 3600000) / 60000);
      const seconds = Math.floor((ms % 60000) / 1000);
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const resetCooldown = async (v) => {
      if (!isAdmin.value) return;
      try {
        await projectFirestore.collection('camps').doc(user.value.uid).update({
          [`villagers.${v.id}.states.lastUsedInAttackAt`]: null,
          updatedAt: FieldValue.serverTimestamp()
        });
      } catch (error) {
        console.error('Error resetting cooldown:', error);
      }
    };

    watch(user, (newUser, oldUser) => {
      if (oldUser && !newUser) {
        cleanupListeners();
      } else if (newUser && newUser.uid !== oldUser?.uid) {
        cleanupListeners();
        setupListeners();
      }
    }, { immediate: true });

    onMounted(() => {
      interval = setInterval(() => {
        currentTime.value = Date.now();
      }, 1000);
    });

    onUnmounted(() => {
      cleanupListeners();
      if (interval) clearInterval(interval);
    });

    return {
      villagers,
      sortedVillagers,
      isLoading,
      handleImageError,
      getTotalStat,
      getLevel,
      getDice,
      onAddClick,
      openDismissModal,
      openUpgradeModal,
      openPowerModal,
      showDismissModal,
      showUpgradeModal,
      showPowerModal,
      selectedVillager,
      handleDismissed,
      handleUpdated,
      remainingMs,
      formatRemaining,
      resetCooldown,
      isAdmin,
      sortBy,
      capacity,
      maxCapacity,
      showCapacityModal,
      openCapacityModal,
      showMigrateModal,
      isMigrating,
      migrateVillagers,
    };
  },
};
</script>
<style scoped>
.bg {
  background: url('https://firebasestorage.googleapis.com/v0/b/zombiekub.firebasestorage.app/o/bg%2Fcamp.png?alt=media&token=3d03c3f1-ebd4-4dd3-bbef-f76896db123e') no-repeat center center fixed,
              linear-gradient(to bottom, rgba(31, 41, 55, 0.8), rgba(0, 0, 0, 0.9));
}
/* Scrollbar */
::-webkit-scrollbar { width: 6px; height: 8px; }
::-webkit-scrollbar-track { background: #374151; border-radius: 10px; }
::-webkit-scrollbar-thumb { background: #4b5563; border-radius: 10px; }
::-webkit-scrollbar-thumb:hover { background: #6b7280; }
</style>